import React from 'react';
import ModalsParamGroup from './ModalsParamGroup';
import ModalsCustomRestriction from './ModalsCustomRestriction';
import ModalsAjustement from './ModalsAjustement';

export default function Modals(props) {
  return (
    <>
      <ModalsParamGroup {...props} />
      <ModalsCustomRestriction {...props} />
      <ModalsAjustement {...props} />
    </>
  );
}
